import { createVNode as o, mergeProps as l } from "vue";
import m from "../node_modules/@pf-ui/pf-icon-svg/es/asn/Right2Filled.js";
import s from "../components/PfIcon.js";
const t = (r, e) => {
  const i = {
    ...r,
    ...e.attrs
  };
  return o(s, l(i, {
    icon: m
  }), null);
};
t.displayName = "Right2Filled";
t.inheritAttrs = !1;
export {
  t as default
};
